export default __webpack_public_path__ + "static/media/gallery_18.c48255cb.jpg";